import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { selectTransactionsInsights } from '../../../store/selectors/transaction-history.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'kt-transactions-insights',
  templateUrl: './transactions-insights.component.html',
  styleUrls: ['./transactions-insights.component.scss'],
})
export class TransactionsInsightsComponent implements OnInit {
  totalTransactionFilter = new FormControl();
  totalFailedTransactionFilter = new FormControl();
  totalTransactionFilterOptions = ['Today', 'This week', 'This month'];
  insights: any;
  totalTransaction = 0;
  totalTransactionNotFiltered = 0;
  totalFailedTransaction = 0;
  monthOverMonthChange = 0;
  selectTransactionsInsights = selectTransactionsInsights;
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.insights = this.store.select(this.selectTransactionsInsights).subscribe((insights) => {
      this.insights = insights;
      this.totalTransaction = insights.totalTransactions;
      this.totalTransactionNotFiltered = insights.totalTransactions;
      this.totalFailedTransaction = insights.totalFailedTransactions;
    });
    this.totalTransactionFilter.valueChanges.subscribe((option) => {
      switch (option) {
        case 'Today':
          this.totalTransaction = this.insights.totalToday;
          break;
        case 'This week':
          this.totalTransaction = this.insights.totalThisWeek;
          break;
        case 'This month':
          this.totalTransaction = this.insights.totalThisMonth;
          break;
        default:
          this.totalTransaction = this.insights.totalTransactions;
      }
    });
    this.totalFailedTransactionFilter.valueChanges.subscribe((option) => {
      switch (option) {
        case 'Decline':
          this.totalFailedTransaction = this.insights.totalFailedTransaction;
          break;
        case 'Network error':
          this.totalFailedTransaction = this.insights.totalFailedTransaction;
          break;
        case 'All':
          this.totalFailedTransaction = this.insights.totalFailedTransaction;
          break;
        default:
          this.totalFailedTransaction = this.insights.totalFailedTransaction;
      }
    });
  }
  getRate(rate: number) {
    return Math.round(rate).toFixed(1);
  }

  getMonthChangesRate(value: number) {
    if (value < 0) return '↓ ' + Math.abs(value);
    return '↑ ' + Math.abs(value);
  }

  getMonthChangesRateColor(value: number) {
    if (value < 0) return 'danger';
    return 'success';
  }
}
